import api from "./api";

export default class CouponApi {
  static async Get(id) {
    return await api.get(`coupon`, id);
  }

  static async Post(data) {
    return await api.post(`coupon`, data);
  }

  static async Del(id) {
    return await api.del(`coupon/${id}`);
  }

  static async GetUsageHistory() {
    return await api.get(`coupon/usage-history/all`);
  }
}
